/**
 * Digitech category icons — official Dark / DarkSelected SVG pack (Fonbet reference).
 * Do NOT use BuilderFont category_icon-* base names: many collide with digi_icon UI
 * glyphs (e.g. category_icon-poker == digi_icon-delete trash).
 */
import { staticAsset } from './staticAssets.js';

const img = staticAsset;
const D = '/content/Casino/categories/Dark';
const DS = '/content/Casino/categories/DarkSelected';
const G = '/content/Casino/categories/gr8';

function pair(iconPath, activePath = iconPath) {
  return { icon: img(iconPath), iconActive: img(activePath), iconClass: null };
}

/** Prefer DarkSelected when present (active chip), else Dark. */
function digi(darkName, selectedName = null) {
  const dark = `${D}/${darkName}`;
  const selected = selectedName ? `${DS}/${selectedName}` : dark;
  return pair(dark, selected);
}

function digiSelected(selectedName) {
  return pair(`${DS}/${selectedName}`);
}

function brand(path) {
  return pair(path);
}

/**
 * Canonical Digitech art by tab / lobby id — mirrors fonbet.by Dark pack paths.
 */
export const CATEGORY_ICON_BY_ID = {
  all: digi('All_games_dark.svg', 'All_games_dark_selected.svg'),
  favourites: digi('Icon_Favourites_dark.svg', 'Icon_Favourites_dark_selected.svg'),
  lastplayed: digi('Icon_LastPlayed_dark.svg'),
  top: digi('Icon_TopGames_dark.svg', 'Icon_TopGames_dark_selected.svg'),
  new: digi('Icon_New_dark-783.svg', 'Icon_New_dark_selected.svg'),
  'buy-bonus': digi('Icon_Buy_bonus__dark.svg', 'Icon_Buy_bonus__dark_selected.svg'),
  'free-spins': digi('Icon_Collect_dark.svg', 'Icon_Collect_dark_selected.svg'),
  exclusive: digi('Icon_Exclusive_dark.svg', 'Icon_Exclusive_dark_selected.svg'),
  jackpot: digi('Icon_Jackpot_dark.svg', 'Icon_Jackpot_dark_selected.svg'),
  megaways: digi('Icon_Megaways_dark.svg', 'Icon_Megaways_dark_selected.svg'),
  multipliers: digi('Icon_Megaways_dark.svg', 'Icon_Megaways_dark_selected.svg'),
  megax: digi('Icon_MegaX_dark.svg', 'Icon_MegaX_dark_selected.svg'),
  cascade: digi('Icon_Cascade_dark.svg', 'Icon_Cascade_dark_selected.svg'),
  collect: digi('Icon_Collect_dark.svg', 'Icon_Collect_dark_selected.svg'),
  wild: digi('Icon_Wild_dark.svg', 'Icon_Wild_dark_selected.svg'),
  double: digi('Icon_DoubleChance_dark.svg', 'Icon_DoubleChance_dark_selected.svg'),
  respin: digi('Icon_Respin_dark.svg', 'Icon_Respin_dark_selected.svg'),
  retro: digi('Icon_Retro_dark.svg', 'Icon_Retro_dark_selected.svg'),
  fruits: digi('Icon_fruits_dark.svg', 'Icon_fruits_dark_selected.svg'),
  books: digi('Icon_Books_dark.svg', 'Icon_Books_dark_selected.svg'),
  tournaments: digi('Icon_Tournaments_dark.svg', 'Icon_Tournaments_dark_selected.svg'),
  'world-cup': digi('Icon_WorldCup2026_dark.svg', 'Icon_WorldCup2026_dark_selected.svg'),
  review: digi('Icon_Review_dark.svg', 'Icon_Review_dark_selected.svg'),
  'high-rtp': brand('/digitech/icons/ic_high_rtp.webp'),

  'vip-egt': brand(`${G}/tab-vip-egt.png`),
  'bell-link': brand(`${G}/tab-vip-egt.png`),
  'coins-link-vip': brand(`${G}/tab-coins-link-vip.png`),
  amusnet: brand('/uploads/provider-logos/amusnet.webp'),
  'pragmatic-play': brand('/uploads/provider-logos/pragmatic-play.webp'),

  // Live — Digitech Dark pack (fonbet.by/casino/-1/198)
  roulette: digi('Icon_Roulette_dark.svg'),
  blackjack: digi('Icon_BlackJack_dark.svg'),
  baccarat: digi('Icon_Baccarat_dark.svg'),
  'game-shows': digi('Icon_GameShows_dark.svg'),
  'vip-tables': digi('Icon_VipTables_dark.svg'),
  'poker-live': digi('Icon_Poker_dark.svg'),
  'sic-bo': digi('Icon_SicBo_dark.svg'),
  'jackpot-cards': digi('Icon_JackpotCards_dark.svg'),

  // Poker lobby
  holdem: digi('Icon_Poker_dark.svg'),
  caribbean: digi('Icon_Poker_dark.svg'),
  'video-poker': digi('Icon_video_poker_dark.svg'),

  // Fast games — fonbet.by/casino/-1/284
  crash: digi('Icon_Crash_games_dark.svg'),
  'table-games': digi('Icon_table_games_dark.svg'),
  mines: digi('Icon_Mines_dark.svg'),
  plinko: digi('Icon_plinko_dark.svg'),
  dice: digi('Icon_dice_dark.svg'),
  scratch: digi('Icon_Scratch_games_dark.svg'),
  other: digi('Icon_Other_dark.svg'),
  'fast-football': digiSelected('icon_Virtual_Sport_dark_selected.svg'),
  'action-games': digi('Icon_fast_games_dark.svg'),
  arcade: digi('Icon_fast_games_dark.svg'),
  football: digiSelected('icon_Virtual_Sport_dark_selected.svg'),
  'horse-racing': digiSelected('icon_Virtual_Sport_dark_selected.svg'),
  bingo: digi('Icon_Lottery_Games_dark.svg'),
  'big-x': brand('/digitech/icons/ic_big_x.svg'),

  // TV — fonbet.by/casino/-1/48
  'card-games': digi('Icon_card_games_dark.svg'),
  lottery: digi('Icon_Lottery_Games_dark.svg'),

  // Lobby tabs
  slots: digi('Icon_slots_dark.svg', 'Icon_slots_dark_selected.svg'),
  live: digi('Live_Casino_dark.svg', 'Live_Casino_dark_selected.svg'),
  poker: digi('Icon_Poker_dark.svg'),
  tv: digi('icon_tv_games_dark.svg', 'icon_tv_games_dark_selected.svg'),
  fast: digi('Icon_fast_games_dark.svg', 'Icon_fast_games_dark_selected.svg'),
  virtual: digiSelected('icon_Virtual_Sport_dark_selected.svg'),

  recommended: digi('Icon_Recommended_dark.svg'),
};

export function categoryIcons(id) {
  const hit = CATEGORY_ICON_BY_ID[id];
  if (!hit) return { icon: null, iconActive: null, iconClass: null };
  return {
    icon: hit.icon || null,
    iconActive: hit.iconActive || hit.icon || null,
    iconClass: hit.iconClass || null,
  };
}

export const LOBBY_ACTION_IDS = {
  slots: [
    'all', 'favourites', 'lastplayed', 'top', 'new',
    'vip-egt', 'amusnet', 'buy-bonus', 'megaways', 'jackpot', 'exclusive', 'free-spins',
  ],
  live: [
    'all', 'favourites', 'lastplayed', 'top', 'new',
    'roulette', 'blackjack', 'baccarat', 'game-shows', 'vip-tables', 'poker-live', 'sic-bo',
  ],
  poker: ['all', 'favourites', 'top', 'holdem', 'caribbean', 'video-poker'],
  tv: ['all', 'favourites', 'lastplayed', 'top', 'new', 'card-games', 'lottery'],
  fast: [
    'all', 'favourites', 'tournaments', 'new', 'crash', 'table-games',
    'mines', 'plinko', 'dice', 'scratch', 'other',
  ],
  virtual: ['all', 'favourites', 'top', 'other'],
};

export const LOBBY_HOME_SECTION_IDS = {
  slots: ['top', 'new', 'buy-bonus', 'free-spins', 'exclusive'],
  live: ['top', 'vip-tables', 'new', 'game-shows', 'roulette', 'blackjack', 'baccarat'],
  poker: ['top', 'holdem', 'caribbean', 'video-poker'],
  tv: ['top', 'new', 'card-games', 'lottery'],
  fast: ['tournaments', 'new', 'crash', 'table-games', 'mines', 'plinko'],
  virtual: ['top', 'other'],
};

export const LOBBY_SIDEBAR_IDS = {
  slots: ['all', 'new', 'top', 'buy-bonus', 'free-spins', 'jackpot', 'megaways', 'exclusive'],
  live: ['all', 'new', 'top', 'roulette', 'blackjack', 'baccarat', 'game-shows', 'vip-tables', 'poker-live', 'sic-bo'],
  poker: ['all', 'top', 'holdem', 'caribbean', 'video-poker'],
  tv: ['all', 'new', 'top', 'card-games', 'lottery'],
  fast: ['all', 'tournaments', 'new', 'crash', 'table-games', 'mines', 'plinko', 'dice', 'scratch', 'other'],
  virtual: ['all', 'top', 'other'],
};

export const TAB_META = {
  all: { routeId: '496', labelKey: 'casino.groupsAll', fallback: 'Tümü' },
  favourites: { routeId: '-3', labelKey: 'casino.groupsFavourites', fallback: 'Favoriler' },
  lastplayed: { routeId: 'lastplayed', labelKey: 'casino.groupsLastPlayed', fallback: 'Son oynananlar' },
  top: { routeId: '57', labelKey: 'casino.groupsTop', fallback: 'En iyi oyunlar' },
  new: { routeId: '447', labelKey: 'casino.groupsNew', fallback: 'Yenilikler' },
  'buy-bonus': { routeId: '75', labelKey: 'casino.groupsBonusBuy', fallback: 'Bonus satın al' },
  'free-spins': { routeId: '488', labelKey: 'casino.groupsFreebonus', fallback: 'Free spin' },
  exclusive: { routeId: '494', labelKey: 'casino.tab.exclusive', fallback: "Vurgun'a özel" },
  jackpot: { routeId: '500', labelKey: 'casino.groupsJackpot', fallback: 'Jackpot' },
  megaways: { routeId: '499', labelKey: 'casino.groupsMultipliers', fallback: 'Yüksek çarpan' },
  'vip-egt': { routeId: 'vip-egt', labelKey: 'casino.groupsBellLink', fallback: 'Bell Link' },
  amusnet: { routeId: 'amusnet', labelKey: 'casino.groupsAmusnet', fallback: 'Amusnet' },
  roulette: { routeId: 'roulette', labelKey: 'casino.groupsRoulette', fallback: 'Rulet' },
  blackjack: { routeId: 'blackjack', labelKey: 'casino.groupsBlackjack', fallback: 'Blackjack' },
  baccarat: { routeId: 'baccarat', labelKey: 'casino.groupsBaccarat', fallback: 'Baccarat' },
  'game-shows': { routeId: 'game-shows', labelKey: 'casino.groupsGameShows', fallback: 'Oyun şovları' },
  'vip-tables': { routeId: 'vip-tables', labelKey: 'casino.groupsVipTables', fallback: 'VIP masalar' },
  'poker-live': { routeId: 'poker-live', labelKey: 'casino.groupsPokerLive', fallback: 'Poker' },
  'sic-bo': { routeId: 'sic-bo', labelKey: 'casino.groupsSicBo', fallback: 'Sic Bo' },
  holdem: { routeId: 'holdem', labelKey: 'casino.groupsHoldem', fallback: "Hold'em" },
  caribbean: { routeId: 'caribbean', labelKey: 'casino.groupsCaribbean', fallback: 'Caribbean' },
  'video-poker': { routeId: 'video-poker', labelKey: 'casino.groupsVideoPoker', fallback: 'Video Poker' },
  tournaments: { routeId: '431', labelKey: 'casino.groupsTournaments', fallback: 'Turnuvalar' },
  crash: { routeId: 'crash', labelKey: 'casino.groupsCrash', fallback: 'Crash' },
  'table-games': { routeId: 'table-games', labelKey: 'casino.groupsTableGames', fallback: 'Masa oyunları' },
  mines: { routeId: 'mines', labelKey: 'casino.groupsMines', fallback: 'Mines' },
  plinko: { routeId: 'plinko', labelKey: 'casino.groupsPlinko', fallback: 'Plinko' },
  dice: { routeId: 'dice', labelKey: 'casino.groupsDice', fallback: 'Dice' },
  scratch: { routeId: 'scratch', labelKey: 'casino.groupsScratch', fallback: 'Scratch' },
  other: { routeId: 'other', labelKey: 'casino.groupsOther', fallback: 'Diğer' },
  'card-games': { routeId: 'card-games', labelKey: 'casino.groupsCardGames', fallback: 'Kartlar' },
  lottery: { routeId: 'lottery', labelKey: 'casino.groupsLottery', fallback: 'Loto' },
};

export function lobbyDefs(ids) {
  return (ids || []).map((id) => {
    const meta = TAB_META[id] || { routeId: id, labelKey: `casino.tab.${id}`, fallback: id };
    const icons = categoryIcons(id);
    return {
      id,
      routeId: meta.routeId,
      labelKey: meta.labelKey,
      fallback: meta.fallback,
      icon: icons.icon,
      iconActive: icons.iconActive,
      iconClass: icons.iconClass,
    };
  });
}
